<template>
    <input
      :id="id"
      ref="input"
      v-bind="$attrs"
      :class="[error ? errorClass : '']"
      :type="type"
      :value="value"
      :maxlength="maxlength"
      @input="$emit('input', $event.target.value)"
      @focus="$emit('focus')"
      @keypress="onlyNumberInput"
    />
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    onlyNumber: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 255,
    },
    value: String | Number,
    error: String,
    errorClass: {
      type: String,
      default: 'border-red-400',
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },

    onlyNumberInput ($event) {
      if (this.onlyNumber) {
         let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
         if (keyCode < 48 || keyCode > 57) {
            $event.preventDefault();
         }
      }
    }

  },
}
</script>
